var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.rearrangeSocialIcons()),function(i){return _c('a',{key:i._id,staticClass:"footer-icon--social",attrs:{"href":i.socialUrl,"target":"_blank"}},[_c('fa',{class:_vm.iconStyle,attrs:{"icon":['fab', i.icon]}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }